/* ============================================================
   VIVĀRA — Editable section copy
   ------------------------------------------------------------
   Section copy that legal or brand may need to revise lives here,
   in one place, so it can be edited without touching layout.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- WHY LIQUID ----------------------------------------------
     Deliberately practical language only. "Most bioavailable", "more
     absorbable" and "supports detoxification" are withdrawn and held in
     js/claims.js; do not restore absorption or comparative-superiority
     claims without substantiation on file.
     -------------------------------------------------------------------- */
  window.VIVARA_WHY_LIQUID = {
    eyebrow: "Why Liquid",
    headingLines: ["Pure. Potent.", "Ready when you are."],

    // Neutral temporary body copy — no absorption or superiority claim.
    body:
      "Liquid keeps the resin in a form you can measure by the drop and take in seconds — " +
      "no scooping, no dissolving, no interruption to the day.",

    // Practical attributes only — nothing here asserts an effect.
    qualities: [
      { label: "Measured\nby the drop" },
      { label: "Ready\nin seconds" },
      { label: "Travels\nwith you" },
      { label: "Tradition\nmeets science" }
    ],

    // Comparison remains live HTML (spec §12) with practical rows only.
    // Rows removed from the earlier draft pending substantiation:
    // "Absorption", "Purity", "Potency" — comparative claims.
    comparison: {
      columns: ["Liquid Drops", "Other Forms"],
      rows: [
        { label: "Measured Dosing", liquid: true, other: false },
        { label: "Ready in Seconds", liquid: true, other: false },
        { label: "No Mixing Required", liquid: true, other: false },
        { label: "Travel Ready", liquid: true, other: false },
        { label: "Daily Consistency", liquid: true, other: false },
        { label: "Rounded Taste", liquid: true, other: false }
      ],
      note: null
    }
  };

})();
